/**
 * Generated runtime TestId mirror for frontend/src/features/onboarding/steps/IdentityStep.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const IdentityStepTestIds = {
  btnAddIdentifier: "btn-add-identifier",
  cardTitleExistingIdentifiers: "card-title-existing-identifiers",
  cardTitleExistingIdentities: "card-title-existing-identities",
  cardTitleIdentifiers: "card-title-identifiers",
  cardTitleIdentityAttributes: "card-title-identity-attributes",
  cardTitleIdentityDetails: "card-title-identity-details",
  inputEntryDate: "input-entry-date",
  inputExitDate: "input-exit-date",
  selectIdentityType: "select-identity-type"
} as const;
